import { NgModule } from '@angular/core';
import { DivisionDropdownComponent } from '@app/features/division/widgets/division-dropdown/division-dropdown.component';
import { DivisionSelectionFilterComponent } from '@app/features/division/widgets/division-selection-filter/division-selection-filter.component';
import { SharedModule } from '@app/shared/shared.module';
import { AssignDivisionComponent } from './pages/section/section-new/section-new-form/assign-division/assign-division.component';
import { DivisionTableDivisionsAssignedComponent } from './widgets/division-table-divisions-assigned/division-table-divisions-assigned.component';
@NgModule({
  declarations: [
    DivisionDropdownComponent,
    AssignDivisionComponent,
    DivisionTableDivisionsAssignedComponent,
    DivisionSelectionFilterComponent
  ],
  imports: [SharedModule],
  exports: [
    DivisionDropdownComponent,
    AssignDivisionComponent,
    DivisionTableDivisionsAssignedComponent,
    DivisionSelectionFilterComponent
  ]
})
export class DivisionWidgetsModule {}
